// Beast Data - 妖兽数据管理
// 妖兽成长系统配置，从炼气到金丹阶段

// 妖兽境界定义
export const beastRealms = {
  0: { name: '炼气', multiplier: 1.0, description: '妖兽修炼的基础阶段，体质逐渐增强' },
  1: { name: '筑基', multiplier: 1.5, description: '妖兽灵智开启，能力显著提升' },
  2: { name: '金丹', multiplier: 2.0, description: '妖兽凝结金丹，拥有强大灵力' }
};

// 妖兽类型配置
export const beastTypes = {
  // 后山妖兽
  mountain_beasts: {
    wolf: {
      name: '灰狼',
      description: '普通的山林妖兽，敏捷而凶猛',
      baseStats: {
        qi: 30,      // 血量 (降低)
        attack: 6,   // 攻击力 (降低)
        defense: 8,  // 防御力
        speed: 12    // 速度
      },
      skills: ['撕咬', '扑击'],
      dropItems: ['狼皮', '兽肉'],
      appearanceRate: 0.4
    },
    bear: {
      name: '黑熊',
      description: '力量强大的森林霸主，防御力惊人',
      baseStats: {
        qi: 80,
        attack: 20,
        defense: 15,
        speed: 6
      },
      skills: ['熊抱', '拍击'],
      dropItems: ['熊胆', '熊掌'],
      appearanceRate: 0.25
    },
    tiger: {
      name: '猛虎',
      description: '山林之王，速度和力量并重',
      baseStats: {
        qi: 70,
        attack: 25,
        defense: 10,
        speed: 15
      },
      skills: ['虎扑', '爪击'],
      dropItems: ['虎皮', '虎骨'],
      appearanceRate: 0.2
    },
    eagle: {
      name: '苍鹰',
      description: '天空的猎手，飞行能力出众',
      baseStats: {
        qi: 45,
        attack: 18,
        defense: 5,
        speed: 20
      },
      skills: ['俯冲', '爪抓'],
      dropItems: ['鹰羽', '鹰眼'],
      appearanceRate: 0.15
    }
  },

  // 秘境妖兽
  mystical_beasts: {
    fox: {
      name: '灵狐',
      description: '聪慧的灵兽，善于幻术和速度',
      baseStats: {
        qi: 60,
        attack: 12,
        defense: 6,
        speed: 18
      },
      skills: ['幻影', '狐火'],
      dropItems: ['狐尾', '灵珠'],
      appearanceRate: 0.35
    },
    deer: {
      name: '灵鹿',
      description: '优雅的灵兽，速度极快，善于逃脱',
      baseStats: {
        qi: 55,
        attack: 8,
        defense: 7,
        speed: 22
      },
      skills: ['跳跃', '角击'],
      dropItems: ['鹿茸', '灵草'],
      appearanceRate: 0.3
    },
    serpent: {
      name: '青蛇',
      description: '毒牙利齿的灵蛇，攻击带有毒性',
      baseStats: {
        qi: 50,
        attack: 16,
        defense: 5,
        speed: 14
      },
      skills: ['毒咬', '缠绕'],
      dropItems: ['蛇胆', '蛇皮'],
      appearanceRate: 0.25
    },
    bird: {
      name: '彩雀',
      description: '美丽的灵鸟，拥有治愈能力',
      baseStats: {
        qi: 40,
        attack: 10,
        defense: 4,
        speed: 16
      },
      skills: ['歌唱', '治愈'],
      dropItems: ['彩羽', '灵果'],
      appearanceRate: 0.1
    }
  },

  // 云海妖兽
  cloud_beasts: {
    dragon: {
      name: '云龙',
      description: '云中神兽，掌控风雨雷电',
      baseStats: {
        qi: 100,
        attack: 30,
        defense: 12,
        speed: 10
      },
      skills: ['雷击', '龙息'],
      dropItems: ['龙鳞', '龙珠'],
      appearanceRate: 0.1
    },
    phoenix: {
      name: '火凤',
      description: '火焰神鸟，重生能力强大',
      baseStats: {
        qi: 90,
        attack: 28,
        defense: 8,
        speed: 14
      },
      skills: ['火焰', '重生'],
      dropItems: ['凤羽', '火精'],
      appearanceRate: 0.08
    },
    thunderbird: {
      name: '雷鸟',
      description: '雷电操控者，速度如闪电',
      baseStats: {
        qi: 75,
        attack: 22,
        defense: 9,
        speed: 25
      },
      skills: ['闪电', '风暴'],
      dropItems: ['雷晶', '鸟羽'],
      appearanceRate: 0.15
    },
    cloud_beast: {
      name: '云兽',
      description: '云雾化形的灵兽，善于隐匿',
      baseStats: {
        qi: 65,
        attack: 14,
        defense: 11,
        speed: 13
      },
      skills: ['隐身', '云雾'],
      dropItems: ['云丝', '雾珠'],
      appearanceRate: 0.25
    }
  },

  // 禁地妖兽（高阶）
  forbidden_beasts: {
    demon_lord: {
      name: '魔王',
      description: '禁地中的强大魔兽，实力恐怖',
      baseStats: {
        qi: 150,
        attack: 40,
        defense: 20,
        speed: 8
      },
      skills: ['魔爪', '黑暗'],
      dropItems: ['魔核', '魔血'],
      appearanceRate: 0.05
    },
    ancient_beast: {
      name: '古兽',
      description: '远古遗留下来的强大妖兽',
      baseStats: {
        qi: 120,
        attack: 35,
        defense: 18,
        speed: 12
      },
      skills: ['远古之力', '石化'],
      dropItems: ['古骨', '灵髓'],
      appearanceRate: 0.08
    },
    shadow_panther: {
      name: '影豹',
      description: '阴影中潜行的致命猎手',
      baseStats: {
        qi: 85,
        attack: 28,
        defense: 10,
        speed: 30
      },
      skills: ['潜行', '暗杀'],
      dropItems: ['影皮', '夜晶'],
      appearanceRate: 0.2
    }
  }
};

// 妖兽技能配置
export const beastSkills = {
  // 物理攻击技能
  '撕咬': { damage: 1.2, type: 'physical', description: '用利齿撕咬敌人' },
  '扑击': { damage: 1.1, type: 'physical', description: '猛扑向敌人' },
  '熊抱': { damage: 1.5, type: 'physical', description: '用力抱住敌人造成重伤' },
  '拍击': { damage: 1.3, type: 'physical', description: '用熊掌拍击' },
  '虎扑': { damage: 1.4, type: 'physical', description: '虎跃扑击' },
  '爪击': { damage: 1.2, type: 'physical', description: '锋利的爪击' },
  '俯冲': { damage: 1.3, type: 'physical', description: '从天而降的攻击' },
  '爪抓': { damage: 1.1, type: 'physical', description: '用爪子抓挠' },
  '角击': { damage: 1.2, type: 'physical', description: '用角攻击' },
  '毒咬': { damage: 1.0, type: 'poison', description: '带有毒性的咬击', effect: { poison: 5 } },
  '缠绕': { damage: 0.8, type: 'physical', description: '缠绕敌人限制行动', effect: { stun: 1 } },

  // 特殊技能
  '幻影': { damage: 0.5, type: 'illusion', description: '制造幻影迷惑敌人', effect: { confuse: 2 } },
  '狐火': { damage: 1.0, type: 'fire', description: '狐火攻击' },
  '跳跃': { damage: 1.1, type: 'physical', description: '高跳攻击' },
  '歌唱': { damage: 0.3, type: 'heal', description: '治愈歌唱', effect: { heal: 10 } },
  '治愈': { damage: 0.2, type: 'heal', description: '治愈光环', effect: { heal: 15 } },
  '雷击': { damage: 1.8, type: 'lightning', description: '雷电攻击' },
  '龙息': { damage: 1.6, type: 'fire', description: '龙之吐息' },
  '火焰': { damage: 1.4, type: 'fire', description: '火焰喷射' },
  '重生': { damage: 0.1, type: 'heal', description: '凤凰重生', effect: { revive: 30 } },
  '闪电': { damage: 1.5, type: 'lightning', description: '闪电链' },
  '风暴': { damage: 1.2, type: 'wind', description: '风暴攻击', effect: { area: true } },
  '隐身': { damage: 0.5, type: 'illusion', description: '隐身潜行', effect: { stealth: 3 } },
  '云雾': { damage: 0.8, type: 'wind', description: '云雾干扰', effect: { blind: 2 } },

  // 禁地技能
  '魔爪': { damage: 2.0, type: 'dark', description: '黑暗魔爪' },
  '黑暗': { damage: 1.5, type: 'dark', description: '黑暗吞噬', effect: { fear: 2 } },
  '远古之力': { damage: 1.8, type: 'earth', description: '远古力量' },
  '石化': { damage: 1.0, type: 'earth', description: '石化凝视', effect: { petrify: 3 } },
  '潜行': { damage: 1.3, type: 'shadow', description: '阴影潜行' },
  '暗杀': { damage: 2.2, type: 'shadow', description: '致命暗杀' }
};

// 妖兽成长计算函数
export function calculateBeastStats(baseStats, realm, level) {
  const realmMultiplier = beastRealms[realm].multiplier;
  const levelMultiplier = 1 + (level - 1) * 0.1; // 每级提升10%

  return {
    qi: Math.floor(baseStats.qi * realmMultiplier * levelMultiplier),
    attack: Math.floor(baseStats.attack * realmMultiplier * levelMultiplier),
    defense: Math.floor(baseStats.defense * realmMultiplier * levelMultiplier),
    speed: Math.floor(baseStats.speed * realmMultiplier * levelMultiplier)
  };
}

// 根据位置获取妖兽类型
export function getBeastTypesForLocation(location) {
  switch (location) {
    case '后山':
      return beastTypes.mountain_beasts;
    case '秘境':
      return beastTypes.mystical_beasts;
    case '云海':
      return beastTypes.cloud_beasts;
    case '禁地':
      return beastTypes.forbidden_beasts;
    default:
      return beastTypes.mountain_beasts; // 默认后山
  }
}

// 随机生成妖兽
export function generateRandomBeast(location) {
  const beastTypePool = getBeastTypesForLocation(location);
  const beasts = Object.keys(beastTypePool);

  // 根据出现率生成权重
  let totalWeight = 0;
  const weights = beasts.map(beast => {
    const weight = beastTypePool[beast].appearanceRate;
    totalWeight += weight;
    return weight;
  });

  // 随机选择妖兽
  let random = Math.random() * totalWeight;
  let selectedBeast = null;

  for (let i = 0; i < beasts.length; i++) {
    random -= weights[i];
    if (random <= 0) {
      selectedBeast = beasts[i];
      break;
    }
  }

  if (!selectedBeast) selectedBeast = beasts[0];

  const beastConfig = beastTypePool[selectedBeast];
  const realm = Math.floor(Math.random() * 3); // 0-2 随机境界
  const level = Math.floor(Math.random() * 10) + 1; // 1-10 随机等级

  return {
    id: `${selectedBeast}_${Date.now()}`,
    type: selectedBeast,
    name: beastConfig.name,
    description: beastConfig.description,
    realm: realm,
    level: level,
    stats: calculateBeastStats(beastConfig.baseStats, realm, level),
    skills: beastConfig.skills,
    dropItems: beastConfig.dropItems,
    currentQi: calculateBeastStats(beastConfig.baseStats, realm, level).qi
  };
}

// 获取妖兽境界名称
export function getBeastRealmName(realm) {
  return beastRealms[realm]?.name || '未知';
}
